import { CTA } from '@/components/sections'
import EnterpriseEcosystem from '@/components/sections/EnterpriseEcosystem'
import { Bento3, EnterpriseFeatures } from '@/components/sections'
import VideoContainer from '@/components/sections/VideoContainer/VideoContainer'
import { Hero } from '@/components/sections/Hero/Hero'
import { mcpData } from '@/config/mcpData'
import PageWrapper from '@/components/layout/PageWrapper'

const Mcp = () => {
  return (
    <PageWrapper
      title="Cobalt MCP - Enterprise Systems Integration Layer"
      description="Cobalt MCP connects SAP, Oracle, Workday and 300+ enterprise systems, orchestrating 10,000+ actions on a secure platform."
      keywords={["MCP", "enterprise systems", "SAP integration", "Oracle integration", "AI workflows"]}
    >
      <Hero
        tag={mcpData.hero.tag}
        cta={mcpData.hero.cta}
        title={<>{mcpData.hero.title}</>}
        description={<div dangerouslySetInnerHTML={{ __html: mcpData.hero.description }} />}
      />

      <VideoContainer
        videoSrc={mcpData.videoContainer.videoSrc}
        description={mcpData.videoContainer.description}
        className={mcpData.videoContainer.className}
      />

      <EnterpriseFeatures
        title={mcpData.enterpriseFeatures.title}
        subtitle={mcpData.enterpriseFeatures.subtitle}
        features={mcpData.enterpriseFeatures.features}
      />

      <Bento3
        title="How It Works"
        description="Deploy in minutes. Execute at enterprise scale."
        items={mcpData.bentoItems}
      />

      <EnterpriseEcosystem
        title={mcpData.enterpriseEcosystem.title}
        description={mcpData.enterpriseEcosystem.description}
        applications={mcpData.enterpriseEcosystem.applications}
        extraText={mcpData.enterpriseEcosystem.extraText}
      />

      <CTA
        title={mcpData.cta.title}
        description={mcpData.cta.description}
        cta={mcpData.cta.cta}
      />
    </PageWrapper>
  )
}

export default Mcp